import React from 'react';

import {WBAgentRunFilterContextSlice} from '../../../aria/externalBindings/WBAgentContextSlices';
import {WBAgentSetFilterActionSlice} from '../../../aria/externalBindings/WBAgentSetFilterActionSlice';
import {type Ref} from '../../../state/views/filter/types';
import {usePart} from '../../../state/views/hooks';
import {WBTableActionFilterButton} from '../WBTable/WBTableActionsFilter';

interface RunsFilterButtonProps {
  compact?: boolean;
  filtersOpen: boolean;
  filtersRef: Ref;
  extraFilterCount?: number;
}

export const RunsFilterButton = (props: RunsFilterButtonProps) => {
  const filters = usePart(props.filtersRef);

  return (
    <WBTableActionFilterButton
      compact={props.compact}
      filtersOpen={props.filtersOpen}
      filters={filters}
      extraFilterCount={props.extraFilterCount}
    />
  );
};

/**
 * Zero-DOM agent context and actions for the run filters. Rendered as a sibling
 * of the filter button rather than alongside it, because Dialog.Trigger hands
 * press behaviour to its first child and so cannot be given a fragment.
 */
export const RunsFilterAgentSlices = ({filtersRef}: {filtersRef: Ref}) => {
  const filters = usePart(filtersRef);

  return (
    <>
      <WBAgentRunFilterContextSlice filters={filters} />
      <WBAgentSetFilterActionSlice filtersRef={filtersRef} />
    </>
  );
};
